import Image from 'next/image';
import styles from './overlay-gradient.module.scss';

const OverlayGradient = () => {
  return (
    <div className={styles.background}>
      <Image
        src="/svgs/gradient-bg.svg"
        alt="background"
        layout="fill"
        objectFit="cover"
        priority
      />
    </div>
  );
};

export default OverlayGradient;
